import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/base/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import ScrollToTop from '@/components/base/ScrollToTop';

const siteUrl = 'https://tianbaolaowu.cn';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/d9pdodosenbniolesth0';

function getFAQSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫漫画网上的漫画是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，韩漫漫画网上的所有韩国漫画均为免费下拉式阅读，无需付费即可在线阅读高清漫画内容。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫漫画网更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们每日更新漫画内容，确保读者能够第一时间阅读到最新的韩国漫画章节。热门漫画通常会在原版发布后24小时内更新。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在韩漫漫画网上找到想看的漫画？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过首页的分类导航、排行榜、热门标签来浏览漫画。网站按照恋爱、奇幻、动作、悬疑等多种类型进行分类，方便您快速找到感兴趣的漫画。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫漫画网是否需要注册账号？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '目前韩漫漫画网无需注册账号即可自由阅读所有漫画内容，方便您随时开始阅读。',
        },
      },
    ],
  };
}

export default function AboutPage() {
  const seoData = {
    title: '关于我们_韩漫漫画网_品牌介绍_联系方式',
    description: '韩漫漫画网致力于为中文读者提供最新最全的韩国漫画资源。了解我们的品牌故事、团队理念以及联系方式，获取最优质的韩漫阅读体验。',
    keywords: '韩漫漫画网,关于我们,品牌介绍,联系方式,韩漫平台,漫画网站',
    canonical: `${siteUrl}/about`,
    ogType: 'website',
    schema: [getFAQSchema()],
  };

  const breadcrumbItems = [
    { label: '首页', href: '/' },
    { label: '关于我们' },
  ];

  return (
    <>
      <SEOHead data={seoData} />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-14">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <Breadcrumb items={breadcrumbItems} />

            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
              关于我们
            </h1>

            {/* Brand Introduction */}
            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                品牌介绍
              </h2>
              <div className="prose max-w-none text-foreground-700 leading-relaxed text-base space-y-4">
                <p>
                  <strong>韩漫漫画网</strong>成立于2020年，是国内领先的韩国漫画在线阅读平台。我们专注于为中文读者提供最新、最全、最高质量的韩国漫画资源，致力于打造中文互联网上最优秀的韩漫阅读社区。
                </p>
                <p>
                  我们的团队由一群热爱漫画的年轻人组成，核心成员来自互联网和动漫行业，拥有丰富的产品运营和内容管理经验。我们深知读者对于优质漫画内容的渴望，因此始终坚持以用户体验为核心，不断优化产品功能。
                </p>
                <p>
                  目前，韩漫漫画网已收录超过<strong>5000部</strong>韩国漫画作品，涵盖恋爱、奇幻、动作、悬疑、搞笑、恐怖、耽美、剧情等全部分类。每日更新超过<strong>100部</strong>作品，累计服务超过<strong>500万</strong>漫画爱好者。
                </p>
              </div>
            </section>

            {/* Our Values */}
            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                我们的理念
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    icon: 'ri-heart-line',
                    title: '热爱漫画',
                    desc: '因为热爱，所以专注。我们团队中的每一个人都是狂热的漫画爱好者，这份热爱驱动我们不断追求卓越。',
                  },
                  {
                    icon: 'ri-shield-check-line',
                    title: '品质至上',
                    desc: '我们严格筛选每一部上架的漫画作品，确保画质清晰、翻译准确，为读者提供最优质的阅读体验。',
                  },
                  {
                    icon: 'ri-user-heart-line',
                    title: '用户为本',
                    desc: '读者的需求是我们前进的方向。我们持续倾听用户反馈，不断优化产品，让阅读变得更加轻松愉快。',
                  },
                ].map((item) => (
                  <div key={item.title} className="p-6 rounded-lg bg-background-100">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="text-base font-semibold text-foreground-900 mb-2">{item.title}</h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            {/* Reputation */}
            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {[
                  {
                    stat: '500万+',
                    label: '累计用户',
                    desc: '深受漫画爱好者信赖',
                  },
                  {
                    stat: '4.8',
                    label: '用户评分',
                    desc: '来自真实用户的高度评价',
                  },
                  {
                    stat: '99.9%',
                    label: '服务可用率',
                    desc: '7×24小时稳定在线',
                  },
                ].map((item) => (
                  <div key={item.label} className="text-center p-6 rounded-lg bg-background-100">
                    <div className="text-3xl font-heading font-bold text-primary-500 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                      {item.stat}
                    </div>
                    <div className="text-sm font-semibold text-foreground-900 mb-1">{item.label}</div>
                    <div className="text-xs text-foreground-500">{item.desc}</div>
                  </div>
                ))}
              </div>
            </section>

            {/* Contact */}
            <section className="mb-14">
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-600">contact@tianbaolaowu.cn</p>
                      <p className="text-xs text-foreground-500">（商务合作、版权事务）</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-customer-service-2-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">客服支持</h4>
                      <p className="text-sm text-foreground-600">support@tianbaolaowu.cn</p>
                      <p className="text-xs text-foreground-500">（问题反馈、使用帮助）</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-600">北京市朝阳区望京SOHO T2</p>
                    </div>
                  </div>
                </div>

                {/* Contact Form */}
                <div className="p-6 rounded-lg bg-background-100">
                  <h4 className="text-base font-semibold text-foreground-900 mb-4">发送消息</h4>
                  <form
                    data-readdy-form
                    className="space-y-4"
                    onSubmit={async (e) => {
                      e.preventDefault();
                      const form = e.currentTarget;
                      const honeypot = (form.querySelector('[name="website_alt"]') as HTMLInputElement)?.value?.trim();
                      if (honeypot) {
                        const msgEl = document.getElementById('contact-form-msg');
                        if (msgEl) {
                          msgEl.textContent = '消息已发送，我们会尽快回复！';
                          msgEl.className = 'mt-4 text-sm text-green-600';
                        }
                        return;
                      }
                      const submitBtn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
                      const msgEl = document.getElementById('contact-form-msg');
                      if (submitBtn) submitBtn.disabled = true;
                      try {
                        const formData = new FormData(form);
                        const resp = await fetch(SUBMIT_ADDR, {
                          method: 'POST',
                          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                          body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
                        });
                        const text = await resp.text();
                        let serverMsg = '';
                        try {
                          const parsed = JSON.parse(text);
                          serverMsg = parsed?.meta?.message || parsed?.message || '';
                        } catch { /* ignore */ }
                        if (resp.ok && !serverMsg.includes('spam')) {
                          if (msgEl) {
                            msgEl.textContent = '消息已发送，我们会尽快回复！';
                            msgEl.className = 'mt-4 text-sm text-green-600';
                          }
                          form.reset();
                        } else {
                          if (msgEl) {
                            msgEl.textContent = serverMsg || '发送失败，请稍后重试';
                            msgEl.className = 'mt-4 text-sm text-red-500';
                          }
                        }
                      } catch {
                        if (msgEl) {
                          msgEl.textContent = '网络错误，请稍后重试';
                          msgEl.className = 'mt-4 text-sm text-red-500';
                        }
                      } finally {
                        if (submitBtn) submitBtn.disabled = false;
                      }
                    }}
                  >
                    <div>
                      <label htmlFor="contact-name" className="block text-sm text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        name="name"
                        type="text"
                        required
                        className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        name="email"
                        type="email"
                        required
                        className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm text-foreground-700 mb-1.5">留言内容</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-3 py-2.5 rounded-lg border border-background-300 bg-background-50 text-sm text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                        placeholder="请输入您的留言（最多500字）"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="website_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="contact-hp"
                    />
                    <button
                      type="submit"
                      className="w-full px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                    <div id="contact-form-msg"></div>
                  </form>
                </div>
              </div>
            </section>

            {/* FAQ */}
            <section>
              <h2 className="text-xl font-heading font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                常见问题
              </h2>
              <div className="space-y-3">
                {[
                  { q: '韩漫漫画网上的漫画是免费的吗？', a: '是的，韩漫漫画网上的所有韩国漫画均为免费下拉式阅读，无需付费即可在线阅读高清漫画内容。' },
                  { q: '韩漫漫画网更新频率如何？', a: '我们每日更新漫画内容，确保读者能够第一时间阅读到最新的韩国漫画章节。热门漫画通常会在原版发布后24小时内更新。' },
                  { q: '如何在韩漫漫画网上找到想看的漫画？', a: '您可以通过首页的分类导航、排行榜、热门标签来浏览漫画。网站按照恋爱、奇幻、动作、悬疑等多种类型进行分类，方便您快速找到感兴趣的漫画。' },
                  { q: '韩漫漫画网是否需要注册账号？', a: '目前韩漫漫画网无需注册账号即可自由阅读所有漫画内容，方便您随时开始阅读。' },
                ].map((faq) => (
                  <details key={faq.q} className="group rounded-lg bg-background-100 p-5 cursor-pointer">
                    <summary className="flex items-center justify-between font-medium text-foreground-900 text-sm list-none">
                      {faq.q}
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </details>
                ))}
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}